import { Button as LoadableButton } from "@tremor/react";

export default { LoadableButton }